<template>
  <v-container id="invoices" fluid tag="section">
    <v-btn-toggle rounded style="float: left; background: transparent">
      <v-btn
        small
        :color="invoiceTab === 'created' ? 'secondary' : 'grey'"
        @click="filterTab('created')"
      >
        <h3 style="padding-right: 20px">
          <div
            style="width: 20px; height: 12px; float: left"
            v-if="invoiceTab !== 'created'"
          ></div>
          <v-icon v-if="invoiceTab === 'created'" color="white"
            >mdi-check</v-icon
          >
          <v-badge
            color="pink"
            :content="invoiceStats.draft"
            :value="invoiceStats.draft"
            >Draft</v-badge
          >
        </h3>
      </v-btn>
      <v-btn
        small
        :color="invoiceTab === 'verified' ? 'secondary' : 'grey'"
        @click="filterTab('verified')"
      >
        <h3 style="padding-right: 20px">
          <div
            style="width: 20px; height: 12px; float: left"
            v-if="invoiceTab !== 'verified'"
          ></div>
          <v-icon v-if="invoiceTab === 'verified'" color="white"
            >mdi-check</v-icon
          >
          <v-badge
            color="deep-orange"
            :content="invoiceStats.ready"
            :value="invoiceStats.ready"
            >Verified</v-badge
          >
        </h3>
      </v-btn>

      <v-btn
        small
        :color="invoiceTab === 'paymentCleared' ? 'secondary' : 'grey'"
        @click="filterTab('paymentCleared')"
      >
        <h3 style="padding-right: 20px">
          <div
            style="width: 20px; height: 12px; float: left"
            v-if="invoiceTab !== 'paymentCleared'"
          ></div>
          <v-icon v-if="invoiceTab === 'paymentCleared'" color="white"
            >mdi-check</v-icon
          >
          <v-badge
            color="green"
            :content="invoiceStats.paymentDone"
            :value="invoiceStats.paymentDone"
            >Payment Done</v-badge
          >
        </h3>
      </v-btn>

      <v-btn
        small
        :color="invoiceTab === 'all' ? 'secondary' : 'grey'"
        @click="filterTab('all')"
      >
        <h3 style="padding-right: 20px">
          <div
            style="width: 20px; height: 12px; float: left"
            v-if="invoiceTab !== 'all'"
          ></div>
          <v-icon v-if="invoiceTab === 'all'" color="white">mdi-check</v-icon
          >All
        </h3>
      </v-btn>

      <v-btn
        small
        :color="invoiceTab === 'create' ? 'secondary' : 'grey'"
        @click="filterTab('create')"
      >
        <h3 style="padding-right: 20px">
          <div
            style="width: 20px; height: 12px; float: left"
            v-if="invoiceTab !== 'create'"
          ></div>
          <v-icon v-if="invoiceTab === 'create'" color="white">mdi-check</v-icon
          >Create Invoice
        </h3>
      </v-btn>
    </v-btn-toggle>

    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="secondary" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="invDownload(null)">
            <v-list-item-title>
              <router-link v-if="$ha(760)" :to="'/sales/invoice/manual'">
                {{ $i18n.t("Create Manual Invoice") }}
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="statusUpdate">
            <v-list-item-title>{{
              $i18n.t("Bulk Status Update")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="bulkRecalculateInvoiceFare">
            <v-list-item-title>{{
              $i18n.t("Bulk Recalculate Fare")
            }}</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item @click="clientBulkModification">
            <v-list-item-title>{{
              $i18n.t("Modify Client")
            }}</v-list-item-title>
          </v-list-item> -->
          <v-list-item @click="deleteSelected">
            <v-list-item-title>{{
              $i18n.t("Delete Selected")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="bulkReCreateInvoice">
            <v-list-item-title>{{
              $i18n.t("Bulk Recreate")
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-dialog v-model="showFilter" transition="dialog-top-transition">
      <v-card>
        <v-toolbar color="secondary" dark fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-filter</v-icon>
            {{ $i18n.t("Filter") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <z-client-select
                :multiple="true"
                :label="$i18n.t('Client')"
                class="purple-input"
                v-model="filter.client_id"
              />
            </v-col>
            <v-col cols="12" md="6">
              <z-entity-select
                :multiple="true"
                :showCorpNames="true"
                :label="$i18n.t('Billing Entity')"
                class="purple-input"
                :corp="filter.client_id"
                v-model="filter.clientEntity_id"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <z-entity-select
                :multiple="true"
                :showCorpNames="false"
                :label="$i18n.t('Shipping Entity')"
                class="purple-input"
                :corp="filter.client_id"
                v-model="filter.shippedToEntity_id"
              />
            </v-col>
            <v-col cols="12" md="6">
              <z-entity-select
                :multiple="true"
                :showCorpNames="true"
                :label="$i18n.t('Supplier Entity')"
                class="purple-input"
                corp="self"
                v-model="filter.vendorEntity_id"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2">
              <v-select
                :items="statusTypes"
                clearable
                :label="$i18n.t('Status')"
                v-model="filter.status"
                item-text="name"
                item-value="value"
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                :items="invoiceTypes"
                clearable
                :label="$i18n.t('Invoice Type')"
                v-model="filter.invoiceType"
                item-text="name"
                item-value="value"
              ></v-select>
            </v-col>

            <v-col cols="12" md="2">
              <z-date-picker
                :label="$i18n.t('From Date')"
                class="purple-input"
                v-model="filter.fromDate"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-date-picker
                :label="$i18n.t('Till Date')"
                class="purple-input"
                v-model="filter.toDate"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-date-picker
                :label="$i18n.t('Due Date From')"
                class="purple-input"
                v-model="filter.fromDueDate"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-date-picker
                :label="$i18n.t('Due Date Till')"
                class="purple-input"
                v-model="filter.toDueDate"
              />
            </v-col>

            <v-col cols="12" md="2">
              <z-date-picker
                :label="$i18n.t('Bookings From')"
                class="purple-input"
                v-model="filter.bookingFromDate"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-date-picker
                :label="$i18n.t('Bookings Till')"
                class="purple-input"
                v-model="filter.bookingToDate"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                :items="financialYears"
                :label="$i18n.t('Financial Year')"
                item-text="name"
                item-value="value"
                v-model="filter.financialYear"
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Invoice No')"
                class="purple-input"
                v-model="filter.invoiceNo"
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <v-text-field
                class="purple-input"
                v-model="filter.amountFrom"
                label="Amount From"
                prefix="₹"
                type="number"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <v-text-field
                class="purple-input"
                v-model="filter.amountTo"
                label="Amount To"
                prefix="₹"
                type="number"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Booking No')"
                class="purple-input"
                v-model="filter.bookingNo"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Duty Slip No')"
                class="purple-input"
                v-model="filter.dutySlipNo"
              />
            </v-col>

            <v-col cols="12" md="2">
              <v-checkbox
                v-model="filter.individual"
                :label="$i18n.t('For Individual')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="filter.notForindividual"
                :label="$i18n.t('Not For Individual')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="filter.deleted"
                :label="$i18n.t('Deleted')"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <v-spacer></v-spacer>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mr-0"
                color="orange"
                fab
                text
                small
                @click="downloadInvoice()"
                style="margin-right: 10px !important"
                v-on="on"
              >
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </template>
            <span>{{ $i18n.t("Download") }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mr-0"
                color="grey darken"
                fab
                text
                small
                @click="clear(1)"
                style="margin-right: 10px !important"
                v-on="on"
              >
                <v-icon>mdi-cached</v-icon>
              </v-btn>
            </template>
            <span>{{ $i18n.t("Clear Filter") }}</span>
          </v-tooltip>
          <v-btn
            color="success"
            class="mr-0"
            fab
            small
            dark
            @click="search()"
            :loading="loading"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="download.showDialog"
      transition="dialog-top-transition"
      style="width:40%; !important"
    >
      <v-card>
        <v-toolbar color="white" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-filter</v-icon>
            {{ $i18n.t("Download") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="download.showDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    :items="download.types"
                    :label="$i18n.t('Select Format')"
                    item-text="name"
                    item-value="_id"
                    v-model="download.template"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <v-spacer></v-spacer>
          <v-btn
            color="orange"
            class="mr-0"
            fab
            small
            dark
            @click="downloadAll()"
            :loading="loading"
          >
            <v-icon>mdi-cloud-download</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showStatusUpdate" transition="dialog-top-transition">
      <v-card>
        <v-toolbar color="cyan" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-filter</v-icon>
            {{ $i18n.t("Bulk Status Update") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="showStatusUpdate = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <span>Current Status</span>
                  <br />
                  <span>
                    <b>{{ getStatusStr(statusSelected) }}</b>
                  </span>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    :items="statusListForUpdate"
                    :label="$i18n.t('New Status')"
                    dense
                    v-model="newStatus"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="mr-0"
            fab
            small
            dark
            @click="saveStatusModification()"
            :loading="loading"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="clientBulkModificationModal"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar color="cyan" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-filter</v-icon>
            {{ $i18n.t("Bulk Client Update") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="clientBulkModificationModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <v-label>Vendor</v-label>
                  <br />
                  <span>
                    <b>{{ vendorNameModifi }}</b>
                  </span>
                </v-col>
                <v-col cols="12" md="3">
                  <v-label>From Client</v-label>
                  <br />
                  <span>
                    <b>{{ clientNameModifi }}</b>
                  </span>
                </v-col>
                <v-col cols="12" md="2">
                  <z-client-select
                    class="purple-input"
                    v-model="newClient_id"
                    :label="$i18n.t('To Client')"
                    withSelf
                  ></z-client-select>
                </v-col>
                <v-col cols="12" md="2">
                  <z-entity-select
                    class="purple-input"
                    :corp="newClient_id"
                    v-model="newClientEntity_id"
                    :label="$i18n.t('Client Entity')"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="mr-0"
            fab
            small
            dark
            @click="saveClientModification()"
            :loading="loading"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn
      v-if="!grid.records && invoiceTab != 'create'"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-map-marker-path"
      :title="$i18n.t('Invoices')"
      class="px-5 py-3 small-icon"
      color="primary"
      v-if="grid.records && invoiceTab != 'create'"
    >
      <z-grid-record :grid="grid" class="grid-records" />

      <!-- <v-card
        class="py-0 my-2"
        elevation="1"
        color="blue lighten-5 d-none d-md-flex"
      >
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" md="1"> </v-col>
            <v-col cols="12" md="3">{{ $i18n.t("Invoice Date") }}</v-col>
            <v-col cols="12" md="2">{{ $i18n.t("Client") }}</v-col>
            <v-col cols="12" md="2">{{ $i18n.t("Amounts") }}</v-col>
            <v-col cols="12" md="1">{{ $i18n.t("Type") }}</v-col>
            <v-col cols="12" md="1">{{ $i18n.t("Status") }}</v-col>
            <v-col cols="12" xs="2" sm="1" class="text-center pl-0">{{
              $i18n.t("Action")
            }}</v-col>
          </v-row>
        </v-card-text>
      </v-card> -->

      <v-simple-table>
        <template v-slot:default>
          <thead class="thead">
            <tr>
              <th class="text-left" style="width: 40px">
                <v-checkbox
                  v-model="slelectAll"
                  style="padding: 0; float: left; width: 30px"
                ></v-checkbox>
              </th>
              <th class="text-left">{{ $i18n.t("Invoice No") }}</th>
              <th class="text-left">{{ $i18n.t("Invoice Date") }}</th>
              <th class="text-left">{{ $i18n.t("Due Date") }}</th>
              <!-- <th class="text-left">{{ $i18n.t("Creation Date") }}</th> -->
              <th class="text-left">{{ $i18n.t("Client") }}</th>
              <th class="text-left">{{ $i18n.t("Entity") }}</th>
              <th class="text-left">{{ $i18n.t("Amount") }}</th>
              <th class="text-left">{{ $i18n.t("Collected") }}</th>
              <th class="text-left">{{ $i18n.t("Write Off") }}</th>
              <th class="text-left">{{ $i18n.t("Type") }}</th>
              <th class="text-left">{{ $i18n.t("Status") }}</th>
              <th class="text-center">{{ $i18n.t("Action") }}</th>
            </tr>
          </thead>
          <invoice-row
            v-for="invoice in grid.rows"
            :key="invoice._id"
            :value="invoice"
            @reload="reload"
            :selected="slelectAll"
            @invDownload="invDownload"
            @invEmail="invEmail"
          />
        </template>
      </v-simple-table>

      <!-- <v-card
        v-for="invoice in grid.rows"
        :key="invoice._id"
        class="py-0 my-2"
        elevation="1"
      >
        <invoice-row
          :value="invoice"
          @reload="reload"
          :selected="slelectAll"
          @invDownload="invDownload"
          @invEmail="invEmail"
        />
      </v-card> -->

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>

      <z-invoice-download
        :payload="payload"
        :showDialog="showInvoiceDoanload"
        @closeDialog="closeDialog"
        :isMail="isMail"
        :invoice="invForMail"
      ></z-invoice-download>
    </base-material-card>

    <CreateInvoice
      v-if="invoiceTab == 'create'"
      :appendParam="appendParam"
      :invoiceTab="invoiceTab"
    />
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import InvoiceRow from "@/views/invoice/InvoiceRow.vue";
import CreateInvoice from "@/views/invoice/CreateInvoice.vue";

@Component({
  name: "Invoices",
  components: { InvoiceRow, CreateInvoice },
})
export default class Invoices extends Vue {
  grid = { page: 0, rows: [] };
  url = "/api/invoice/data/grid?sidx=startTime&sord=desc&";
  invoiceTab = "created";
  financialYears = [
    {
      name: "2017-18",
      value: "20170401",
    },
    {
      name: "2018-19",
      value: "20180401",
    },
    {
      name: "2019-20",
      value: "20190401",
    },
    {
      name: "2020-21",
      value: "20200401",
    },
    {
      name: "2021-22",
      value: "20210401",
    },
    {
      name: "2022-23",
      value: "20220401",
    },
    {
      name: "2023-24",
      value: "20230401",
    },
    {
      name: "2024-25",
      value: "20240401",
    },
    {
      name: "2025-26",
      value: "20250401",
    },
    {
      name: "2026-27",
      value: "20260401",
    },
  ];
  invoiceTypes = [
    {
      name: "Manual",
      value: "manual",
    },
    {
      name: "Route",
      value: "1",
    },
    {
      name: "Booking",
      value: "2",
    },
  ];
  statusTypes = [
    {
      name: "Draft",
      value: "0",
    },
    {
      name: "Verified",
      value: "1",
    },
    {
      name: "Payment Collected",
      value: "3",
    },
  ];
  showFilter = false;
  showInvoiceDoanload = false;
  filterUrl = "";
  slelectAll = false;
  on = null;
  page = 1;
  rows = 20;
  client = null;
  payload = {};
  tab = 1;
  // upcomingCnt = 3;
  // inserviceCnt = 2;
  newStatus = "";
  showStatusUpdate = false;
  statusSelected = null;
  statusListForUpdate = [];
  clientNameModifi = null;
  vendorNameModifi = null;
  isMail = false;
  invForMail = null;
  invoiceStats = {};

  clientBulkModificationModal = false;
  newClient_id = null;
  newClientEntity_id = null;

  download = {
    showDialog: false,
    template: "0",
    types: [],
    templateList: [],
    bookingTemplateList: [],
  };

  filter = {
    financialYear: "",
    bookingFromDate: "",
    bookingToDate: "",
    fromDate: "",
    toDate: "",
    fromDueDate: "",
    amountFrom: null,
    amountTo: null,
    toDueDate: "",
    invoiceNo: null,
    client_id: null,
    clientEntity_id: null,
    shippedToEntity_id: null,
    vendor_id: null,
    vendorEntity_id: null,
    bookingNo: null,
    invoiceType: null,
    status: "",
    tripInvoicesrouteNo: "",
    tripInvoicesdutySlipNo: "",
    deleted: null,
    individual: null,
    notForindividual: null,
  };

  get loading() {
    return common.loading;
  }

  async mounted() {
    this.setCurrentFy();
    this.search();
    this.fetchTemplates();
  }

  async fetchTemplates() {
    this.download.templateList = await doGet("/api/template/2/options");
    this.download.bookingTemplateList = await doGet("/api/template/1/options");
  }

  async fetchStats() {
    this.invoiceStats = await doGet("/api/dashboard/invoice/stats");
  }

  setCurrentFy() {
    const dt = new Date();
    const currentYear = dt.getFullYear();
    if (dt.getMonth() > 2) {
      this.filter.financialYear = "" + (currentYear * 10000 + 401);
    } else {
      this.filter.financialYear = "" + ((currentYear - 1) * 10000 + 401);
    }
  }

  closeDialog() {
    this.showInvoiceDoanload = false;
    this.payload = {};
    this.invForMail = null;
    this.isMail = false;
  }

  getTab() {
    if (this.invoiceTab == "draft") return "&tab=created";
    if (this.invoiceTab == "verified") return "&tab=verified";
    if (this.invoiceTab == "verifiedIndividual")
      return "&tab=verifiedIndividual";
    if (this.invoiceTab == "paymentCleared") return "&tab=paymentCleared";
    if (this.invoiceTab == "all") return "&tab=all";
    return "";
  }

  async downloadCoverSheet(excel) {
    let url = "/api/invoices/coversheet/download?excel=" + excel + "&";
    await this.setFilterUrl();
    url = url + this.filterUrl;
    const temp2 = url.split("?")[1].split("&");
    let found = false;
    for (let i = 0; i < temp2.length; i++) {
      if (temp2[i].split("=")[0] == "client_id" && temp2[i].split("=")[1]) {
        found = true;
        break;
      }
    }
    if (!found) {
      common.setError("Please select client to download excel/PDF");
      return;
    }
    url = url + this.getTab();

    if (this.sortBy == "time_asc")
      url += "&sord=" + "asc" + "&sidx=" + "invoiceDate";
    else if (this.sortBy == "time_desc")
      url += "&sord=" + "desc" + "&sidx=" + "invoiceDate";
    else if (this.sortBy == "name_asc")
      url += "&sord=" + "asc" + "&sidx=" + "invoiceNo";
    else if (this.sortBy == "name_desc")
      url += "&sord=" + "desc" + "&sidx=" + "invoiceNo";
    window.open(url, "_blank");
  }

  fetchCookieInfo() {
    if (this.$cookies.get("allow_cookies") == "true") {
      const sortCookie = this.$cookies.get(
        "athena_invoice_sort_" + this.invoiceTab
      );
      if (sortCookie == "time_asc") {
        this.sortBy = "time_asc";
      } else if (sortCookie == "time_desc") {
        this.sortBy = "time_desc";
      } else if (sortCookie == "name_asc") {
        this.sortBy = "name_asc";
      } else if (sortCookie == "name_desc") {
        this.sortBy = "name_desc";
      }
    }
  }

  filterTab(type) {
    this.invoiceTab = type;
    if (this.invoiceTab == "create") {
      return;
    }
    this.search();
  }

  async downloadAll() {
    const type = this.download.template;
    if ("coversheet_pdf" == type) {
      this.downloadCoverSheet(false);
      return;
    }
    if ("coversheet_excel" == type) {
      this.downloadCoverSheet(true);
      return;
    }
    let url = "/api/invoices/download?_search=true";
    await this.setFilterUrl();
    url = url + this.filterUrl;
    if (this.invoiceTab) {
      url = url + "&tab=" + this.invoiceTab;
    }
    if (type) {
      if (type.length > 20) {
        url = url + "&template_id=" + type;
      } else {
        url = url + "&type=" + type;
      }
    }

    this.fetchCookieInfo();

    if (this.sortBy == "time_asc")
      url += "&sord=" + "asc" + "&sidx=" + "invoiceDate";
    else if (this.sortBy == "time_desc")
      url += "&sord=" + "desc" + "&sidx=" + "invoiceDate";
    else if (this.sortBy == "name_asc")
      url += "&sord=" + "asc" + "&sidx=" + "invoiceNo";
    else if (this.sortBy == "name_desc")
      url += "&sord=" + "desc" + "&sidx=" + "invoiceNo";

    window.open(url, "_blank");
  }

  invEmail(_invoice) {
    this.invForMail = _invoice;
    this.isMail = true;
    this.showInvoiceDoanload = true;
  }

  invDownload(_invoice) {
    let ids = "";
    const clients = [];
    let vendor_id, client_id, vendorEntity_id, clientEntity_id;
    let v_consider = true;
    let c_consider = true;
    let vEntity_consider = true;
    let cEntity_consider = true;
    if (_invoice) {
      ids += _invoice._id;
      clients.push(_invoice.client_id);
      vendor_id = _invoice.vendor_id;
      client_id = _invoice.client_id;
      vendorEntity_id = _invoice.vendorEntity._id;
      clientEntity_id = _invoice.clientEntity._id;
    } else {
      this.grid.rows.forEach(function (t) {
        if (t.selected) {
          ids += t._id + ",";
          clients.push(t.client_id);
          if (v_consider) {
            if (vendor_id == null) {
              vendor_id = t.vendor_id;
            } else if (vendor_id != t.vendor_id) {
              v_consider = false;
            }
          }
          if (c_consider) {
            if (client_id == null) {
              client_id = t.client_id;
            } else if (client_id != t.client_id) {
              c_consider = false;
            }
          }
          if (vEntity_consider) {
            if (vendorEntity_id == null) {
              vendorEntity_id = t.vendorEntity._id;
            } else if (vendorEntity_id != t.vendorEntity._id) {
              vEntity_consider = false;
            }
          }
          if (cEntity_consider) {
            if (clientEntity_id == null) {
              clientEntity_id = t.clientEntity._id;
            } else if (clientEntity_id != t.clientEntity._id) {
              cEntity_consider = false;
            }
          }
        }
      });
    }

    if (!ids) {
      common.setError("Please select invoice(s) to download PDF/Excel");
      return false;
    }

    const payload = { invoice_ids: ids, client_ids: clients };
    if (v_consider) {
      payload.vendor_id = vendor_id;
    }
    if (c_consider) {
      payload.client_id = client_id;
    }
    if (vEntity_consider) {
      payload.vendorEntity_id = vendorEntity_id;
    }
    if (cEntity_consider) {
      payload.clientEntity_id = clientEntity_id;
    }
    this.payload = payload;
    this.showInvoiceDoanload = true;
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    const grid = await doGet(
      this.url +
        "rows=" +
        this.rows +
        "&page=" +
        page +
        this.filterUrl +
        "&tab=" +
        this.invoiceTab
    );
    this.fetchStats();
    if (grid.rows && grid.rows.length > 0) {
      for (let i = 0; i < grid.rows.length; i++) {
        grid.rows[i].selected = false;
      }
      this.grid = grid;
    } else {
      this.grid = grid;
    }
    this.showFilter = false;
    common.setLoading(false);
  }

  getStatusStr(status) {
    if (status == 0) {
      return this.$i18n.t("Draft");
    }
    if (status == 1) {
      return this.$i18n.t("Verified");
    }
    if (status == 3) {
      return this.$i18n.t("Payment Collected");
    }
    if (status == 4) {
      return this.$i18n.t("Rejected");
    }
    if (status == 5) {
      return this.$i18n.t("Partially Paid");
    }
    return "";
  }

  async clear() {
    this.filter = {
      financialYear: "",
      bookingFromDate: "",
      bookingToDate: "",
      fromDate: "",
      toDate: "",
      fromDueDate: "",
      toDueDate: "",
      invoiceNo: null,
      client_id: null,
      clientEntity_id: null,
      shippedToEntity_id: null,
      vendor_id: null,
      vendorEntity_id: null,
      bookingNo: null,
      invoiceType: null,
      status: "",
      tripInvoicesrouteNo: "",
      tripInvoicesdutySlipNo: "",
      deleted: null,
      individual: null,
      notForindividual: null,
    };
    this.setCurrentFy();

    this.search();
  }

  appendParam(url, param, val) {
    if (val) {
      url = url + "&" + param + "=" + val;
    }
    return url;
  }

  setFilterUrl() {
    this.filterUrl = "";
    if (this.filter.fromDate) {
      this.filterUrl = this.appendParam(
        this.filterUrl,
        "fromDate",
        this.filter.fromDate
      );
    }
    if (this.filter.amountFrom) {
      this.filterUrl = this.appendParam(
        this.filterUrl,
        "amountFrom",
        this.filter.amountFrom
      );
    }
    if (this.filter.amountTo) {
      this.filterUrl = this.appendParam(
        this.filterUrl,
        "amountTo",
        this.filter.amountTo
      );
    }
    if (this.filter.toDate) {
      this.filterUrl = this.appendParam(
        this.filterUrl,
        "toDate",
        this.filter.toDate
      );
    }
    if (this.filter.fromDueDate) {
      this.filterUrl = this.appendParam(
        this.filterUrl,
        "fromDueDate",
        this.filter.fromDueDate
      );
    }
    if (this.filter.toDueDate) {
      this.filterUrl = this.appendParam(
        this.filterUrl,
        "toDueDate",
        this.filter.toDueDate
      );
    }

    if (this.filter.bookingFromDate && this.filter.bookingToDate) {
      this.filterUrl = this.appendParam(
        this.filterUrl,
        "bookingFromDate",
        this.filter.bookingFromDate
      );
      this.filterUrl = this.appendParam(
        this.filterUrl,
        "bookingToDate",
        this.filter.bookingToDate
      );
    }
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "invoiceNo",
      this.filter.invoiceNo
    );
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "client_id",
      this.filter.client_id
    );
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "clientEntity._id",
      this.filter.clientEntity_id
    );
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "shippedToEntity._id",
      this.filter.shippedToEntity_id
    );
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "vendor_id",
      this.filter.vendor_id
    );
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "vendorEntity._id",
      this.filter.vendorEntity_id
    );
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "bookingNo",
      this.filter.bookingNo
    );
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "invoiceType",
      this.filter.invoiceType
    );
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "status",
      this.filter.status
    );
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "tripInvoices.routeNo",
      this.filter.routeNo
    );
    this.filterUrl = this.appendParam(
      this.filterUrl,
      "tripInvoices.dutySlipNo",
      this.filter.dutySlipNo
    );
    if (this.filter.deleted) {
      this.filterUrl = this.appendParam(
        this.filterUrl,
        "deleted",
        true
      );
    }
    if (
      (this.filter.individual || this.filter.notForindividual) &&
      !(this.filter.individual && this.filter.notForindividual)
    ) {
      if (this.filter.individual) {
        this.filterUrl = this.appendParam(this.filterUrl, "individual", true);
      } else {
        this.filterUrl = this.appendParam(this.filterUrl, "individual", false);
      }
    }
    if (this.filter.financialYear)
      this.filterUrl =
        this.filterUrl + "&financialYear=" + this.filter.financialYear;
  }

  search() {
    this.setFilterUrl();
    this.showPage(1);
  }

  downloadInvoice() {
    this.download.types.push({
      _id: "coversheet_pdf",
      name: "CoverSheet - PDF",
    });
    this.download.types.push({
      _id: "coversheet_excel",
      name: "CoverSheet - EXCEL",
    });
    this.download.types.push({ _id: "0", name: "EXCEL 1" });
    this.download.types.push({ _id: "1", name: "EXCEL 2" });
    this.download.types.push({ _id: "2", name: "EXCEL 3" });
    this.download.types.push({ _id: "3", name: "EXCEL 4" });
    if (this.download.templateList) {
      for (let i = 0; i < this.download.templateList.length; i++) {
        this.download.types.push({
          _id: this.download.templateList[i]._id,
          name: this.download.templateList[i].name + "(Template)",
        });
      }
    }
    if (this.download.bookingTemplateList) {
      for (let i = 0; i < this.download.bookingTemplateList.length; i++) {
        this.download.types.push({
          _id: this.download.bookingTemplateList[i]._id,
          name:
            this.download.bookingTemplateList[i].name + "(Booking Template)",
        });
      }
    }
    this.showFilter = false;
    this.download.showDialog = true;
  }

  clientBulkModification() {
    let client_id = null;
    let vendor_id = null;
    let count = 0;
    this.clientNameModifi = this.vendorNameModifi = null;
    for (let i = 0; i < this.grid.rows.length; i++) {
      if (this.grid.rows[i]["selected"]) {
        count++;
        if (client_id != null && client_id != this.grid.rows[i]["client_id"]) {
          common.setError("Please select invoice(s) of same client.");
          return;
        } else {
          client_id = this.grid.rows[i]["client_id"];
          this.clientNameModifi = this.grid.rows[i]["clientName"];
        }

        if (vendor_id != null && vendor_id != this.grid.rows[i]["vendor_id"]) {
          common.setError("Please select invoice(s) of same vendor.");
          return;
        } else {
          vendor_id = this.grid.rows[i]["vendor_id"];
          this.vendorNameModifi = this.grid.rows[i]["vendorName"];
        }
      }
    }

    if (count == 0) {
      common.setError("Please select invoice(s).");
      return;
    }

    if (!client_id) {
      common.setError(
        "Please filter/select inovice according to client first."
      );
      return;
    }

    this.clientBulkModificationModal = true;
  }

  async saveClientModification() {
    let _ids = "";
    for (let i = 0; i < this.grid.rows.length; i++) {
      if (this.grid.rows[i]["selected"]) _ids += this.grid.rows[i]["_id"] + ",";
    }
    const data = {
      invoice_ids: _ids,
      client_id: this.newClient_id,
      clientEntity_id: this.newClientEntity_id,
    };
    common.setLoading(true);
    try {
      await doPost("/api/invoice/bulk/client/modify", data);
      common.showMessage("Client Updated successfully");
      this.reload();
      common.setLoading(false);
      this.clientBulkModificationModal = false;
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  statusUpdate() {
    let _ids = "";
    this.statusSelected = null;
    let status = null;
    for (let i = 0; i < this.grid.rows.length; i++) {
      if (this.grid.rows[i]["selected"]) {
        _ids += this.grid.rows[i]["_id"] + ",";
        if (status != null && status != this.grid.rows[i]["status"]) {
          common.setError("Please select invoice(s) with same status");
          return;
        } else {
          status = this.grid.rows[i]["status"];
        }
      }
    }
    this.statusSelected = status;
    if (this.statusSelected == 3) {
      common.setError("Payment Collected status cannot be changed");
      return false;
    }
    if (!_ids) {
      common.setError("Please select invocie to be updated");
      return;
    }
    this.statusListForUpdate = [];
    if (this.statusSelected == 1) {
      this.statusListForUpdate.push({ text: "Draft", value: "0" });
    }
    if (this.statusSelected == 0 || this.statusSelected == 3) {
      this.statusListForUpdate.push({ text: "Verified", value: "1" });
    }
    if (this.statusSelected == 1) {
      this.statusListForUpdate.push({ text: "Payment Collected", value: "3" });
    }
    this.showStatusUpdate = true;
  }

  async saveStatusModification() {
    let _ids = "";
    let status = this.statusSelected;
    for (let i = 0; i < this.grid.rows.length; i++) {
      if (this.grid.rows[i]["selected"]) {
        _ids += this.grid.rows[i]["_id"] + ",";
        if (status != null && status != this.grid.rows[i]["status"]) {
          common.setError("Please select invoice(s) with same status");
          return;
        } else {
          status = this.grid.rows[i]["status"];
        }
      }
    }
    this.statusSelected = status;
    if (this.statusSelected == 3) {
      common.setError("Payment Collected status cannot be changed");
      return;
    }
    if (!_ids) {
      common.setError("Please select invocie to be updated");
      return;
    }
    const reqData = { invoice_ids: _ids, status: this.newStatus };
    common.setLoading(true);
    try {
      await doPost("/api/invoice/bulk/status/modify", reqData);
      common.showMessage("Status Modified Successfully");
      this.reload();
      this.showStatusUpdate = false;
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      this.showStatusUpdate = false;
      common.setError(e.message);
    }
  }

  async bulkRecalculateInvoiceFare() {
    let _ids = "";
    for (let i = 0; i < this.grid.rows.length; i++) {
      if (this.grid.rows[i]["selected"]) {
        _ids += this.grid.rows[i]["_id"] + ",";
        if (this.grid.rows[i].status != 0) {
          common.setError("Please select invoices with status created");
          return;
        }
      }
    }
    if (!_ids) {
      common.setError("Please select invoices to recalculate");
      return false;
    }

    const data = { invoice_ids: _ids };
    common.setLoading(true);
    try {
      await doPost("/api/invoice/bulk/fare/recalculate", data);
      common.showMessage("Fare recalculated successfully");
      this.reload();
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async bulkReCreateInvoice() {
    let _ids = "";
    let client_id = null;

    for (let i = 0; i < this.grid.rows.length; i++) {
      if (this.grid.rows[i]["selected"]) {
        _ids += this.grid.rows[i]["_id"] + ",";
        if (client_id == null) client_id = this.grid.rows[i].client_id;
        if (this.grid.rows[i].client_id != client_id) {
          common.setError("Please select invoices of same client");
          return;
        }
      }
    }
    if (!_ids) {
      common.setError("Please select invoices to recalculate");
      return false;
    }

    const data = { invoice_ids: _ids };
    common.setLoading(true);
    try {
      await doPost("/api/invoice/bulk/recreate", data);
      common.showMessage("Invoices recreated successfully");
      this.reload();
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async deleteSelected() {
    let ids = "";
    this.grid.rows.forEach(function (t) {
      if (t["selected"]) {
        ids += t["_id"] + ",";
      }
    });
    if (!ids) {
      common.setError("Please select invoices to delete");
      return false;
    }
    const data = { invoice_ids: ids };
    common.setLoading(true);
    try {
      await doPost("/api/invoice/bulk/delete", data);
      common.showMessage("Deleted Successfully");
      this.reload();
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async reload() {
    this.showPage(this.page);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}

tbody:nth-child(even) {
  background: #fafafa;
}
.thead tr th {
  padding: 0 2px !important;
}
</style>
